import TokenSender from "@legacy/@gedesco/reactcomponentsgdc-v2.token-manager/TokenSender"
import {
  Dispatch,
  SetStateAction,
  createContext,
  useCallback,
  useMemo,
  useState,
} from "react"

interface IGlobalTokenSender {
  children: JSX.Element
}

interface IGlobalTokenSenderProps {
  message: string
  setMessage: Dispatch<SetStateAction<string>>
  clearAccountsDomainStorage: () => void
}

export const GlobalTokenSenderContext = createContext<IGlobalTokenSenderProps>(
  {} as IGlobalTokenSenderProps
)

export const GlobalTokenSender = ({ children }: IGlobalTokenSender) => {
  const [message, setMessage] = useState("")

  const clearAccountsDomainStorage = useCallback(() => {
    setMessage(
      JSON.stringify({
        action: "clear",
      })
    )
  }, [setMessage])

  const value = useMemo(
    () => ({
      message,
      setMessage,
      clearAccountsDomainStorage,
    }),
    [message, setMessage, clearAccountsDomainStorage]
  )

  return (
    <GlobalTokenSenderContext.Provider value={value}>
      <div>{children}</div>
      <TokenSender
        message={message}
        targetUrl={import.meta.env.REACT_APP_ACCOUNTS || ""}
      />
    </GlobalTokenSenderContext.Provider>
  )
}
